import { get } from 'lodash';
import { Controller } from '@hotwired/stimulus';
import { isBlank } from '@/libs/strings';
import toast from '@/libs/cifra/toast';
import { t } from '@/libs/i18n';
import { EVENTO_ANTES_CARGAR } from '../modal_remoto_controller';
import GestorSeleccionListado from '../utils/GestorSeleccionListado';

/* global $, Cifra, toastr, swal */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);
    this.gestorSeleccionListado = new GestorSeleccionListado(this.element);
    this.gestorSeleccionListado.connect();

    this.#gestionCambioEstado();
    this.#gestionFraccionarCobro();
    this.#gestionRecordarPago();
  }

  // eslint-disable-next-line class-methods-use-this
  #gestionCambioEstado() {
    this.#anadirParametrosBusquedaModalRemoto(document.getElementById('btn-cambiar-estado'));
  }

  #gestionFraccionarCobro() {
    this.#anadirParametrosBusquedaModalRemoto(document.getElementById('btn-fraccionar-cobro'));
  }

  // eslint-disable-next-line class-methods-use-this
  #gestionRecordarPago() {
    const $botonRecordarPago = $('#btn-recordar-pago');
    if ($botonRecordarPago.data('conectado')) {
      return;
    }
    $botonRecordarPago.data('conectado', true);
    $botonRecordarPago.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const botonSeleccionarTodo = window.Stimulus.getControllerForElementAndIdentifier(
        document.getElementById('boton-marcar-cobros'), 'seleccionar-todo',
      );
      const params = botonSeleccionarTodo ? botonSeleccionarTodo.getParametrosFiltros() : {};
      let texto;
      const url = $(e.currentTarget).attr('href');

      if (params.busqueda_completa) {
        texto = 'Se enviará una notificación de recordatorio de pago para toda la selección actual';
      } else if (!params.ids || params.ids.length === 0) {
        toastr.error('Debe seleccionar algún cobro', 'Recordar pagos');
        return;
      } else if (params.ids.length === 1) {
        texto = 'Se enviará una notificación de recordatorio de pago para el cobro seleccionado';
      } else {
        texto = `Se enviará una notificación de recordatorio de pago para los ${params.ids.length} cobros seleccionados`;
      }

      swal(
        {
          title: 'Recordatorio de pago',
          text: `${texto} ¿Seguro que desea continuar?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: Cifra.Conf.COLOR_CIFRA,
          confirmButtonText: 'Aceptar',
          closeOnConfirm: true,
        },
        // No se puede cambiar la firma de esta función o falla swal
        // eslint-disable-next-line func-names, prefer-arrow-callback
        function (isConfirmed) {
          if (isConfirmed) {
            Cifra.Utils.formPost(url, params);
          }
        },
      );
    });
  }

  /**
   * Cuando se abre el modal remoto para cambiar el estado de los cobros,
   * añadimos los parámetros de selección del listado a la URL del modal
   */
  #anadirParametrosBusquedaModalRemoto(botonModalRemoto) {
    botonModalRemoto.addEventListener(EVENTO_ANTES_CARGAR, (event) => {
      // Añadimos a la URL del modal los ids seleccionados que se van a procesar
      const filtros = this.gestorSeleccionListado.getParametrosFiltros();

      const ids = get(filtros, 'ids');
      if (isBlank(ids)) {
        toast.error(t('error_debe_seleccionar_uno'));
        // Que no abra el modal
        event.preventDefault();
        return;
      }

      Object.keys(filtros).forEach((key) => {
        event.detail.url.searchParams.append(key, filtros[key]);
      });
    });
  }
}
